import React from "react";

import ModalProfiles from "./ModalProfiles";

import Util from "../../../global/utils/Helpers";
import PrefillUtil from "../../../global/utils/prefillHelper";
import ViewEntityQueryResolver from "../../../data/queries/profiles/profilesById/resolver";

class ModalPrefiller extends React.Component {
  constructor() {
    super();
    this.state = {
      selected: [],
    };
    this.selectProfiles = this.selectProfiles.bind(this);
    this.prefill = this.prefill.bind(this);
    this.profiles = [];
    this.counties = undefined;
  }

  componentDidUpdate(prevProps) {
    let filtered_profiles;
    if (this.props.profiles !== prevProps.profiles) {
      filtered_profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.schemaProps.prefill.type;
      });
      this.setState({
        profiles: filtered_profiles,
      });
    }
  }

  componentDidMount() {
    let profiles;
    if (this.props) {
      profiles = this.props.profiles.filter((profile) => {
        return profile.type === this.props.type;
      });

      this.setState({
        profiles,
        counties: this.props.counties ? this.props.counties : undefined,
      });
    }
  }

  //TODO: get profiles
  selectProfiles(value) {
    this.setState({
      selected: this.state.profiles[value],
    });
  }

  prefillSelected = async (new_selected) => {
    let result = await this.prefill(new_selected);
    return result;
  };

  pushSelected = async (new_selected) => {
    this.setState(
      {
        selected: this.state.selected.concat(new_selected),
      },
      async () => {
        let data = this.prefillSelected(new_selected);
        return data;
      }
    );
  };

  prefill = async (new_selected) => {
    if (!Array.isArray(new_selected)) {
      return false;
    }
    const { formApi, machine_name } = this.props;
    let selected_ids = new_selected.map((selected) => selected.id);
    let profilesType = this.props.type + "s";
    //get the data
    selected_ids = JSON.stringify(selected_ids);
    selected_ids =
      selected_ids && JSON.stringify(selected_ids).replace(/"/g, '"');

    const query = ViewEntityQueryResolver(profilesType, selected_ids);
    const data = await Util.handleGraphql(query);
    const dataKeys = PrefillUtil.dataResolver(profilesType);

    let rawData = data.data[dataKeys.query];
    const ProfileRowResolver = PrefillUtil.profileRowResolver(
      profilesType,
      formApi,
      machine_name
    );
    // need a resolver here for each profile item
    rawData.forEach((field) => {
      let profileRow = ProfileRowResolver(field, this.props.form_id);
      formApi.mutators.push(machine_name, profileRow);
    });
    // Return True when the data has been loaded into table (Needs to return true for async to work)
    // see submitNewProfiles function in AddProfilesModal.js **
    return true;
  };

  render() {
    let modalPrefill = this.props;
    return (
      <div>
        <ModalProfiles
          profiles={this.state.profiles}
          pushSelected={this.prefill}
          selected={this.state.selected}
          modalPrefill={modalPrefill}
          type={this.props.type}
          allowOptionsOnlyOnce={this.props.allowOptionsOnlyOnce}
          masterFieldArray={this.props.machine_name}
          formValues={this.props.formApi?.getState().values}
        />
      </div>
    );
  }
}

export default ModalPrefiller;
